import * as React from 'react';
import { isFunction } from '@resi-media/resi-ui';
import { useParams } from 'react-router';
import useSWR from 'swr';
import type { SWRResponse } from 'swr';
import { useEnvironment } from '@sites/contexts/environmentContext';
import { useFeed } from '@sites/contexts/feedContext';
import type CustomError from '@sites/helpers/customError';
import type { Videos } from '@sites/types';

type _Props = {
  children: React.ReactNode | ((values: SWRResponse<Videos.Get.Video, CustomError>) => React.ReactNode);
  tokenData?: { jwt: string };
};

const VideoFetch = ({ children, tokenData: tokenDataProp }: _Props) => {
  const { tokenData: tokenDataCtx } = useFeed();
  const { API_GATEWAY_V1 } = useEnvironment();
  const { videoId } = useParams<'videoId'>();
  const tokenData = tokenDataProp ?? tokenDataCtx;
  const { data, error, isLoading, ...rest } = useSWR<Videos.Get.Video>(
    tokenData?.jwt && videoId ? [`${API_GATEWAY_V1}/ondemand/videos/${videoId}`, tokenData.jwt, videoId] : null
  );

  return (
    <React.Fragment>{isFunction(children) ? children({ data, error, isLoading, ...rest }) : children}</React.Fragment>
  );
};

VideoFetch.displayName = 'VideoFetch';

export { VideoFetch };
